<div class="container-redirect-page">
    <div class="container-redirect-page__text-redirect">
        <h1 class="text-brand-10 ls-h1-page-title-liv2" [innerHTML]="titlePage"></h1>
        <p class="text-neutral-30 ls-p" [innerHTML]="'PAGE_REDIRECT_AVVISI.DESCRIPTION' | translate"></p>
        <button class="btn-primario text-uppercase ls-label-small-semibold" [routerLink]="['/node/2326']" [innerHTML]="'PAGE_REDIRECT_AVVISI.REDIRECT_ALL_NOTICE' | translate"></button>
    </div>
</div>